export const ROWS_PER_PAGE_OPTIONS = [5, 10, 25] as const;
export const DEFAULT_PER_PAGE = 10;

export const isValidPageOptions = (
  value: number
): value is (typeof ROWS_PER_PAGE_OPTIONS)[number] => {
  return (ROWS_PER_PAGE_OPTIONS as readonly number[]).includes(value);
};

export const ROBOT_PER_PAGE = 5;

export const ROBOT_DELETED_LABEL = "（削除済みロボット）";

export const MAP_DELETED_LABEL = "（削除済みマップ）";
